import { BaseAutoTestStep } from './base';
import { errOrData, mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class CustomOutputAutoTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave() {
        const errs = this._checkProgramNotEmpty();
        if (this.data.regex.match(/([^\\]|^)(\\\\)*\\f/) == null) {
            errs.push('The regular expression must contain at least one "\\f"');
        }
        return mergeEithers(this._baseGetDataToSave(), errOrData(errs, { data: this.data, type: this.type }));
    }
}
